import styled, { keyframes } from 'styled-components';
import { DEFAULT_COLORS } from 'components/core/colors';

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const Loader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
  height: 200px;

  svg {
    width: 2rem;
    height: 2rem;
    animation: ${spin} 1s linear infinite;
    color: var(--color-secondary, ${DEFAULT_COLORS.sky.darkest});
  }
`;
